import type { CarrierFolderPublicationProgress } from '@/services/api';

type EffectiveDateInput = Pick<
  CarrierFolderPublicationProgress,
  'foldersCurrent' | 'trafficHistoryEffectiveDate'
>;

export function carrierTrafficHistoryEffectiveDateState(input: EffectiveDateInput) {
  const visible = input.foldersCurrent
    && input.trafficHistoryEffectiveDate.status !== 'not_required';
  const value = input.trafficHistoryEffectiveDate.providerCalendarDate ?? '';
  const needsSelection = input.trafficHistoryEffectiveDate.status !== 'current';
  return {
    visible,
    value,
    message: needsSelection
      ? 'Select the mapping effective date before you run /start-day.'
      : `Traffic History mapping effective date: ${value}.`,
    needsSelection,
  };
}
